export default "__VITE_ASSET__Biq_rdnZ__"